module.exports = __webpack_public_path__ + "779cc700fa5e73ad5f9ab55f711f4bf6.pdf";